import { Model } from '@/models/Model';
import store from "@/store";
import { Profile } from './User';
import i18n from '@/i18n';

export class BoxRequest extends Model {
  protected $name: string = 'BoxRequest';
  protected $endpoint: string = '/box-requests';
  protected $fillable: string[] = [
    'status',
    'type',
    'note',
    'channel',

    // includes
    'info',
  ];
  protected $includes: ListInclude[] = [];
  protected filters: ListFilters = {};

  public id?: string;

  public status?: StatusKey;
  public type?: string;
  public note?: string;
  public channel?: string;
  public created_at?: string;
  public updated_at?: string;
  public status_updated_at?: string;
  public assigned_at?: string;
  public order_count?: number;

  // includes
  public images?: Image[];
  public info?: Info[];
  public orders?: Order[];
  public stylist?: User;
  public user?: User;
  public logs?: Logs;

  public static get statuses(): any {
    // @ts-ignore
    if (store && store.state && store.state.Auth && store.state.Auth.isPlanner()) {
      return {
        'pending': 'Pending',
        'on_hold_other': 'On Hold: Other',
        'on_hold_photos': 'On Hold: Photo\'s',
        'on_hold_credit_check': 'On Hold: Credit check',
        'to_be_contacted': 'To be contacted',
        'waiting_for_reply': 'Waiting for reply',
        'order_in_progress': 'To be styled',
        'completed': 'Completed',
        'no_reply': 'No reply',
        'canceled': 'Cancelled',
        'planned': 'Planned',
      };
    }

    return {
      'to_be_contacted': i18n.tc('filters.statusFilter.toBeContacted'),
      'waiting_for_reply': i18n.tc('filters.statusFilter.waitingForReply'),
      'no_reply': i18n.tc('filters.statusFilter.noReply'),
      'order_in_progress': i18n.tc('filters.statusFilter.orderInProgress'),
      'completed': i18n.tc('filters.statusFilter.completed'),
    };
  }

  public async updateBoxRequestStatus(id: string, payload: { status: StatusKey }): Promise<any> {
    const url = `${this.$endpoint}/${id}`;
    return this.request('patch', url, this.getPayload(payload));
  }

  public deleteRequest(id: string) {
    const url = `/box-requests/${id}`;

    return this.request('delete', url, {});
  }

  public getInProgress(userId: any): Promise<any> {
    const url = `/box-requests/user/${userId}/get-in-progress`;

    return this.request("get", url);
  }
}

type Image = {};

type Info = {
  id?: string;
  key?: string;
  value?: string;
  created_at?: string;
  updated_at?: string;
};

type Logs = {
  created_at: string;
  from_status: StatusKey;
  note: string;
  to_status: StatusKey;
  updated_at: string;
}

type Links = {
  self?: string;
};

export type ListFilters = {
  search?: string;
  status?: string; // FIXME: ENDPOINT MISSING
  stylist?: string;
  type?: string; // FIXME: ENDPOINT MISSING
  user?: string;
}

export type ListInclude =
  'user'
  | 'stylist'
  | 'orders'
  | 'info'
  | 'images'
  | 'meta'
  | 'referral_code'
  | 'logs';

export type ReadInclude = ListInclude;

type Order = {};

export type StatusKey =
  'pending'
  | 'planned'
  | 'on_hold_photos'
  | 'on_hold_credit_check'
  | 'on_hold_budget'
  | 'on_hold_other'
  | 'to_be_contacted'
  | 'waiting_for_reply'
  | 'no_reply'
  | 'order_in_progress'
  | 'backorder'
  | 'completed'
  | 'canceled';

export type Statuses = {
  [key in StatusKey]: string;
};

type User = {
  id?: string;
  name?: string;
  first_name?: string;
  middle_name?: string;
  last_name?: string;
  email?: string;
  has_mfa?: string;
  created_at?: string;
  updated_at?: string;
  links?: Links;
  profile?: Profile;
};
